import { RootState } from '~/store';

export const getListOfLinksReducer = (state: RootState) => state.listOfLinksReducer;
